import React, { useState, useEffect, useMemo } from 'react';
import { Tab, Tabs } from '../../../../../components/common/TabCustom';
import { Loading } from '../../../../../components/common';
import DeclaracionesJuradasGrid from '../../../../../components/controls/DeclaracionesJuradasGrid';
import DeclaracionesJuradasPendientesGrid from '../../../../../components/controls/DeclaracionesJuradasPendientesGrid';
import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { usePermissions } from '../../../../../components/hooks/usePermissions';
import { PERMISSIONS } from '../../../../../consts/permissions';
import { ServerRequest } from '../../../../../utils/apiweb';
import { APIS } from '../../../../../config/apis';

const DeclaracionesJuradasTab = ({ state, UpdateEntity }) => {

    const [activeTab, setActiveTab] = useState('declaracionesJuradasPresentadas');
    const [pendientes, setPendientes] = useState([]);
    const [loading, setLoading] = useState(false);

    const { hasPermission } = usePermissions();
    const canEditDeclaracionJurada = hasPermission(PERMISSIONS.DECLARACION_JURADA_EDIT);

    const idCuenta = state.entity.cuenta.id;

    const idsPresentadas = useMemo(() =>
        state.entity.declaracionesJuradas
            .filter(f => f.id > 0)
            .map(x => x.id)
            .sort((a, b) => a - b)
            .join(','),
        [state.entity.declaracionesJuradas]);

    useEffect(() => {
        if (idCuenta > 0) FindPendientes(idCuenta);
    }, [idCuenta, idsPresentadas]);

    const cantidadNoPresentadas = pendientes.filter(f => !f.enTermino).length;
    const titlePendientes = (cantidadNoPresentadas > 0)
        ? `Períodos a presentar (${cantidadNoPresentadas})`
        : 'Períodos a presentar';

    function FindPendientes(idCuenta) {
        setLoading(true);

        const paramsUrl = `/pendientes/cuenta/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.MODELO_DECLARACION_JURADA,
            paramsUrl,
            null,
            callbackSuccessPendientes,
            callbackNoSuccess,
            callbackError
        );
    }

    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message);
            setLoading(false);
        })
        .catch((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error);
            setLoading(false);
        });
    }

    const callbackError = (error) => {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando solicitud: ' + error.message);
        setLoading(false);
    }

    const callbackSuccessPendientes = (response) => {
        response.json()
        .then((data) => {
            setPendientes(data);
            setLoading(false);
        })
        .catch((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error);
            setLoading(false);
        });
    }

    return (
        <>
            <Loading visible={loading}></Loading>

            <Tabs
                id="tabs-comercio-declaraciones-juradas"
                activeKey={activeTab}
                className="m-top-10"
                onSelect={tab => setActiveTab(tab)}
            >
                <Tab eventKey="declaracionesJuradasPresentadas" title="Presentadas">
                    <div className='tab-panel'>
                        <DeclaracionesJuradasGrid
                            processKey={state.processKey}
                            disabled={state.mode === OPERATION_MODE.VIEW || !canEditDeclaracionJurada}
                            data={{
                                idCuenta: state.entity.cuenta.id,
                                idTipoTributo: state.entity.cuenta.idTipoTributo,
                                list: state.entity.declaracionesJuradas
                            }}
                            onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                        />
                    </div>
                </Tab>
                <Tab eventKey="declaracionesJuradasPendientes" title={titlePendientes}>
                    <div className='tab-panel'>
                        <DeclaracionesJuradasPendientesGrid
                            data={{
                                list: pendientes
                            }}
                        />
                    </div>
                </Tab>
            </Tabs>
        </>
    )
}

export default DeclaracionesJuradasTab
